import { Typography, styled } from '@mui/material';

const ButtonCaptionText = styled(Typography)`
  font-size: 0.6rem;
  line-height: 1;
  color: black;
`;

export default ButtonCaptionText;
